import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	NgZone,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';
import { Location, NgIf, NgClass, NgFor } from '@angular/common';
import { MatOption, MatOptionModule } from '@angular/material/core';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { forkJoin, map, of, Subject, Subscription, switchMap } from 'rxjs';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';

import { SoldToRelationshipGroup } from '../../../../shared/models/service';
import { FormNeed4SteelOffer } from '../../../models/form-mill-offer';
import { BocClient } from '../../../../shared/models/boc-client-transac';
import { TranslationService } from '../../../../shared/services/translation.service';
import { UserService } from '../../../../shared/services/user.service';
import { WizardPageContent } from '../wizard-page-content';
import { MillOfferService } from '../../../services/mill-offer.service';
import { Need4SteelWizardService } from '../../../services/need4steel-wizard.service';
import { Need4SteelWizardStepperService } from '../../../services/need4steel-wizard-stepper.service';
import { Need4SteelWizardStep } from '../../../models/need4steel-wizard-state';
import { CodeValue } from '../../../../shared/models/code-value';
import { safe } from '../../../../shared/utils/safe';
import {
	MillOfferNeed4Steel, State, getTmodeTrKey, INCOTERM_CIP, DEFAULT_INCOTERM, DEFAULT_TRANSPORT_MODE
} from '../../../models/need4steel';
import { UNDERSCORE } from '../../../../shared/components/utils/constants';
import { UsageAnalytics } from '../../../../shared/services/usage-analytics.service';
import { UsageEvent } from '../../../../shared/models/usage-event';
import { StepProductSpecificationComponent } from '../step-product-specification/step-product-specification.component';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';
import { SortOptionsPipe } from '../../../../shared/pipes/sorting.pipe';
import { N4sShipmentCacheService } from '../../../services/n4s-shipment-cache.service';

const DEFAULT_HEADER_SCROLLINDEX = -1;
@Component({
	selector: 'copo-need4steel-step-header',
	templateUrl: './step-header.component.html',
	styleUrl: './step-header.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		LoadingSpinnerComponent,

		MatFormFieldModule,
		TranslateModule,

		MatInputModule,
		FormsModule,
		ReactiveFormsModule,
		MatIconModule,
		NgClass,

		MatSelectModule,

		MatOptionModule,
		NgFor,

		MatTooltipModule,

		MatButtonModule,
		StepProductSpecificationComponent,
		SortOptionsPipe
	]
})

export class StepHeaderComponent extends WizardPageContent implements OnDestroy, OnInit {
	@ViewChild('coNbrField', { read: ElementRef }) coNbrField!: ElementRef<MatInput>;

	@ViewChild('soldToField', { read: ElementRef }) soldToField!: ElementRef<MatOption>;

	@ViewChild('shipToField', { read: ElementRef }) shipToField!: ElementRef<MatOption>;
	@ViewChild('endUserField', { read: ElementRef }) endUserField?: ElementRef<MatOption>;
	@ViewChild('scrollRef') scrollRef!: ElementRef<HTMLElement>;
	millOfferData?: MillOfferNeed4Steel;

	iddList?: CodeValue[];
	tmodList?: CodeValue[];
	incotList?: CodeValue[];
	userBocData?: SoldToRelationshipGroup[];
	soldToList?: string[];
	readonly form: FormNeed4SteelOffer;
	wasChecked = false;
	isLoading = true;
	isShipmentSelectionEnabled = false;
	isShipToSoldTo = true;
	isSoldTo = true;
	isShipTo = true;
	showEndUserSelection = false;
	bocs?: Map<string, BocClient>;
	soldToBocList?: BocClient[];
	millSite?: string;
	formdeliveryDate?: string;
	millOfferId?: string;
	state: State;
	configForBoc = { codeProp: 'businessId', valueProp: 'name' };
	scrollEventSubscription?: Subscription;
	readonly UNDERSCORE = UNDERSCORE;
	private readonly defaultTmodList: CodeValue[] = [
		{
			code: DEFAULT_TRANSPORT_MODE,
			value: getTmodeTrKey(DEFAULT_TRANSPORT_MODE)
		}
	];

	private readonly shipToEventSubject: Subject<void> = new Subject<void>();

	private sub: Subscription | undefined;
	private exchangeRateSubscription?: Subscription;
	private readonly VIEW_STEP_NUM = 0;

	constructor(
		public usageAnalytics: UsageAnalytics,
		private readonly millOfferService: MillOfferService,
		private readonly need4steelWizardService: Need4SteelWizardService,
		private readonly userService: UserService,
		private readonly translationService: TranslationService,
		private readonly need4steelStepperService: Need4SteelWizardStepperService,
		private readonly changeDetectorRef: ChangeDetectorRef,
		readonly location: Location,
		readonly ngZone: NgZone,
		private readonly router: Router,
		private readonly shipmentCacheService: N4sShipmentCacheService
	) {
		super(Need4SteelWizardStep.HEADER, need4steelWizardService.getState());
		this.form = this.need4steelWizardService.getStateOfferForm();
		this.state = <State> location.getState();
		this.millOfferId = this.state.millOfferId || '';
		this.loadParameters();
	}

	get isError() {
		return this.need4steelWizardService.getState().errorInPage;
	}

	get shipToEvent() {
		return this.shipToEventSubject.asObservable();
	}

	getFormOffer() {
		return this.need4steelWizardService.getStateOfferForm();
	}

	ngOnInit() {
		this.millOfferData = this.millOfferService.millOffer;
		if (this.millOfferData) {
			this.millSite = this.millOfferData.millSiteDescription || UNDERSCORE;
			this.formdeliveryDate = `W${ String(this.millOfferData.deliveryWeek)
			}/${ String(this.millOfferData.deliveryYear) } - ${ String(this.millOfferData.iddDescription) }`;
			this.form.getFormDeliveryDate().setValue(this.formdeliveryDate);
			this.form.getFormMill().setValue(this.millSite);
			this.isShipmentSelectionEnabled = this.need4steelWizardService.isShipmentSelectionEnabled(
				this.millOfferData.millSite
			);
			if (this.isShipmentSelectionEnabled) {
				this.tmodList = this.defaultTmodList;
				if (!this.form.getFormTmode().value) {
					this.form.getFormTmode().setValue(DEFAULT_TRANSPORT_MODE);
				}
			}
		}
		this.loadExchangeRateIfNeeded();
		this.need4steelStepperService.onStepChanged.emit({ step: this.VIEW_STEP_NUM });
		this.scrollEventSubscription = this.need4steelWizardService.getTriggerScrollObservable().subscribe(index => {
			this.scrollToRow(index);
		});
	}

	scrollToRow(index: number) {
		if (index === DEFAULT_HEADER_SCROLLINDEX) {
			this.scrollRef.nativeElement.scroll();
		}
	}

	ngOnDestroy() {
		if (this.sub) {
			this.sub.unsubscribe();
		}
		this.exchangeRateSubscription?.unsubscribe();
	}

	checkError() {
		this.wasChecked = true;
		this.form.getFormCoNbr().markAsTouched();
		this.form.getFormSoldTo().markAsTouched();
		this.form.getFormShipTo().markAsTouched();
		this.form.getFormEndUser().markAsTouched();
		this.form.getFormDeliveryDate().markAsTouched();
		this.form.getFormMill().markAsTouched();
		if (!this.form.getFormCoNbr().valid) {
			this.coNbrField.nativeElement.focus();
			return true;
		}
		if (!this.form.getFormSoldTo().valid) {
			this.soldToField.nativeElement.focus();
			return true;
		}
		if (!this.form.getFormShipTo().valid) {
			this.shipToField.nativeElement.focus();
			return true;
		}
		if (!this.form.getFormEndUser().valid) {
			this.endUserField?.nativeElement.focus();
			return true;
		}
		return false;
	}

	getShipToList() {
		const soldToBusinessId = <string> this.form.getFormSoldTo().value;
		const soldToGroup = soldToBusinessId && this.userBocData
			? this.userBocData.find(v => v.soldTo === soldToBusinessId)
			: undefined;
		const filteredShipToList = this.getFilteredShipToList(soldToGroup);
		this.millOfferService.filteredSoldtoShiptoList = filteredShipToList;
		return filteredShipToList;
	}

	getEndUserList() {
		const soldToBusinessId = <string> this.form.getFormSoldTo().value;
		const soldToGroup = soldToBusinessId && this.userBocData
			? this.userBocData.find(v => v.soldTo === soldToBusinessId)
			: undefined;
		return soldToGroup && this.bocs
			? soldToGroup.endUsers.map(v => this.bocs?.get(v)).filter((v): v is BocClient => v !== undefined)
			: [];
	}

	getFilteredShipToList(soldToGroup: SoldToRelationshipGroup | undefined) {
		const { bocs } = this;
		if (soldToGroup && bocs) {
			return soldToGroup.shipTos.map(v => bocs.get(v)).filter(
				(v): v is BocClient => v !== undefined
			);
		}
		return [];
	}

	changeSoldTo() {
		const soldToBusinessId = <string> this.form.getFormSoldTo().value;
		const soldToGroup = soldToBusinessId && this.userBocData
			? this.userBocData.find(v => v.soldTo === soldToBusinessId)
			: undefined;
		const { bocs } = this;
		if (bocs) {
			const boc = bocs.get(soldToBusinessId);
			if (boc) {
				this.millOfferService.boc = boc;
			}
		}
		this.setupDefaultShipTo(soldToGroup);
		this.setupEndUser(soldToGroup);
		this.setupDefaultPayer(soldToGroup);
		this.isShipTo = true;
		if (soldToGroup && bocs && soldToGroup.shipTos.length === 0) {
			this.isShipTo = false;
		} else {
			this.need4steelWizardService.soldToChangeEvent(soldToBusinessId);
		}
	}

	setShipTo(event: MatSelectChange) {
		const shipTo = <string> event.value;
		this.form.getFormShipTo().setValue(shipTo);
		if (this.isShipmentSelectionEnabled) {
			this.updateShipmentForShipTo(shipTo);
		} else {
			this.applyDefaultIncotermForShipTo(shipTo);
		}
		this.shipToEventSubject.next();
	}

	setEndUser(event: MatSelectChange) {
		this.form.getFormEndUser().setValue(event.value);
		this.need4steelWizardService.endUserChangeEvent();
	}

	setSoldTo(event: MatSelectChange) {
		const soldTo = <string> event.value;
		this.form.getFormSoldTo().setValue(soldTo);
	}

	async checkSoldTo() {
		if (!this.isSoldTo) {
			this.millOfferService.setOfferListErrorMsg(
				this.translationService.getTR('need4steel.soldto.shipto.error.message')
			);
			await this.router.navigate(['/need4steel/offerlist'], { replaceUrl: true });
		}
	}

	async checkMillOfferId() {
		if (!(this.state.millOfferId || this.need4steelWizardService.isMillOfferIdPresent())) {
			this.millOfferService.setOfferListErrorMsg(this.translationService.getTR('need4steel.offer.error.message'));
			await this.router.navigate(['/need4steel/offerlist'], { replaceUrl: true });
		}
	}

	async sendN4sData(soldToId: string, codeUnitRef?: string, codeSubUnitRef?: string, codeSubSubUnitRef?: string) {
		const deliveryWeek = String(this.millOfferData?.deliveryWeek);
		const deliveryYear = String(this.millOfferData?.deliveryYear);
		const usageEvent: UsageEvent = {
			code: 'OFFER',
			soldto: soldToId,
			offerWeek: 'W'.concat(`${ deliveryWeek }/${ deliveryYear }`),
			offerProduct: this.millOfferData?.category,
			offerProductForm: this.millOfferData?.form,
			offerProductName: this.millOfferData?.subCategory,
			offerMill: this.millOfferData?.millSite,
			offerRfq: this.millOfferData?.rfqNumber,
			dealType: this.millOfferData?.dealType,
			codeUnitRef,
			codeSubUnitRef,
			codeSubSubUnitRef
		};
		await this.usageAnalytics.sendUsageAnalyticsEvent(usageEvent);
	}

	getSoldToBocListSize(soldToBocList: BocClient[]) {
		return soldToBocList.length;
	}

	hasExchangeRateToDisplay(): boolean {
		return this.need4steelWizardService.shouldDisplayExchangeRate();
	}

	shouldHighlightExchangeRate(): boolean {
		return this.need4steelWizardService.shouldHighlightExchangeRate();
	}

	getExchangeRateDisplayReferenceDate(): string | undefined {
		return this.need4steelWizardService.getExchangeRateDisplayReferenceDate();
	}

	getExchangeRateDisplayValue(): string | undefined {
		return this.need4steelWizardService.getExchangeRateDisplayValue();
	}

	getExchangeRateDisplayCurrency(): string | undefined {
		return this.need4steelWizardService.getExchangeRateDisplayCurrency();
	}

	onTmodeChange(event: MatSelectChange) {
		const shipToId = <string> this.form.getFormShipTo().value;
		if (!shipToId) {
			return;
		}
		const shipments = this.shipmentCacheService.getShipmentsForShipTo(shipToId);
		const selected = shipments.find(s => s.tmode === event.value);
		this.form.getFormIncoterm().setValue(selected?.incoterm ?? DEFAULT_INCOTERM);
		this.shipToEventSubject.next();
	}

	private loadExchangeRateIfNeeded() {
		if (!this.need4steelWizardService.shouldDisplayExchangeRate()) {
			return;
		}
		this.exchangeRateSubscription = this.need4steelWizardService.loadExchangeRates().subscribe({
			next: () => {
				this.changeDetectorRef.markForCheck();
			},
			error: (err: unknown) => {
				console.error('error loading exchange rate', err);
				this.changeDetectorRef.markForCheck();
			}
		});
	}

	private loadParameters() {
		this.sub = forkJoin([
			this.millOfferService.getBocs()
				.pipe(switchMap(userBocData => {
					if (userBocData.length === 0) {
						return of(<const>[userBocData, <BocClient[]>[]]);
					}
					const businessIds = Array.from(
						new Set(userBocData.flatMap(v => [v.soldTo, ...v.shipTos, ...v.endUsers]))
					);
					return forkJoin([
						of(userBocData),
						this.userService.findBocs(
							[
								'businessId',
								'name',
								'city',
								'address',
								'country',
								'postalCode',
								'referenceCommercialUnit',
								'referenceCommercialSubUnit',
								'referenceCommercialSubSubUnit'
							],
							businessIds.map(x => `businessId:${ x }`).join(' OR ')
						).pipe(map(v => v.results))
					]);
				}))
		]).subscribe({
			next: async ([[userBocData, bocs]]) => {
				this.userBocData = userBocData;
				this.need4steelWizardService.userBocData = userBocData;
				for (const boc of bocs) {
					const { country } = boc;
					boc.countryCode = country;
					const lang = this.translationService.getLangWithRegion();
					const regionNames = new Intl.DisplayNames([lang], { type: 'region' });
					const countryName = (country ? regionNames.of(country) : undefined) || undefined;
					if (countryName) {
						boc.country = countryName;
					}
				}
				if (!this.userService.user.readOnly) {
					const soldToDetails = bocs.filter(o1 => userBocData.find(o2 => o1.businessId === o2.soldTo));
					for (const userboc of soldToDetails) {
						await this.ngZone.runOutsideAngular(async () => {
							await this.sendN4sData(
								userboc.businessId,
								userboc.referenceCommercialUnit?.codeUnit,
								userboc.referenceCommercialSubUnit?.codeSubUnit,
								userboc.referenceCommercialSubSubUnit?.codeSubSubUnit
							);
						});
					}
				}
				this.sub = undefined;
				this.isLoading = false;
				const bocsMap = this.bocs = new Map(bocs.map(v => [v.businessId, v]));
				this.millOfferService.bocs = bocsMap;
				this.soldToList = this.userBocData.map(v => v.soldTo);
				this.soldToBocList = this.soldToList.map(v => safe(bocsMap.get(v)));
				this.setupDefaultSoldTo(this.soldToBocList);
				const soldToBusinessId = <string> this.form.getFormSoldTo().value;
				const soldToGroup = soldToBusinessId ? this.userBocData.find(v => v.soldTo === soldToBusinessId)
					: undefined;
				this.setupDefaultShipTo(soldToGroup);
				this.setupEndUser(soldToGroup);
				this.setupDefaultPayer(soldToGroup);
				const errorMsg = await this.checkSoldToShipToError();
				await this.checkSoldTo();
				await this.checkMillOfferId();
				if (errorMsg !== undefined) {
					this.need4steelWizardService.getState().errorInPage = true;
				}
				if (this.isShipmentSelectionEnabled && !this.shipmentCacheService.isLoaded()) {
					const allShipToIds = Array.from(new Set(
						(this.userBocData ?? []).flatMap(v => v.shipTos)
					));
					await this.shipmentCacheService.loadCache(allShipToIds, 'ND4ST');
					this.updateShipmentForShipTo(<string> this.form.getFormShipTo().value);
					this.changeDetectorRef.markForCheck();
				} else if (this.isShipmentSelectionEnabled) {
					this.updateShipmentForShipTo(<string> this.form.getFormShipTo().value);
				} else {
					this.applyDefaultIncotermForShipTo(<string> this.form.getFormShipTo().value);
				}
			},
			error: (err: unknown) => {
				console.error('error loading wizard parameters', err);
				this.sub = undefined;
				this.isLoading = false;
				this.isShipToSoldTo = false;
				this.isSoldTo = false;
				this.need4steelWizardService.getState().errorInPage = true;
				this.millOfferService.showError(
					this.translationService.getTR('eoffer.wizard.parameters.error')
				);
			},
		});
	}

	private setupDefaultSoldTo(soldToBocList: BocClient[]) {
		if (soldToBocList.length === 1 && (this.form.getFormSoldTo().value === null
			|| !this.form.getFormSoldTo().value)) {
			for (const soldTo of soldToBocList) {
				this.millOfferService.boc = soldTo;
				this.form.getFormSoldTo().setValue(soldTo.businessId);
			}
		}
	}

	private setupDefaultShipTo(soldToBocList?: SoldToRelationshipGroup) {
		if (soldToBocList && soldToBocList.shipTos.length === 1) {
			this.millOfferService.filteredSoldtoShiptoList = this.getFilteredShipToList(soldToBocList);
			this.form.getFormShipTo().setValue(soldToBocList.shipTos[0]);
			if (!this.isShipmentSelectionEnabled) {
				this.applyDefaultIncotermForShipTo(soldToBocList.shipTos[0]);
			}
		}
	}

	private setupEndUser(soldToGroup?: SoldToRelationshipGroup) {
		const endUsers = soldToGroup?.endUsers ?? [];
		const previousEndUser = String(this.form.getFormEndUser().value ?? '');
		this.showEndUserSelection = endUsers.length > 1;

		if (endUsers.length === 0) {
			this.form.getFormEndUser().setValue(this.form.getFormSoldTo().value);
		} else if (endUsers.length === 1) {
			this.form.getFormEndUser().setValue(endUsers[0]);
		} else if (!endUsers.includes(previousEndUser)) {
			this.form.getFormEndUser().setValue(undefined);
		}

		if (previousEndUser !== this.form.getFormEndUser().value) {
			this.need4steelWizardService.endUserChangeEvent();
		}
	}

	private setupDefaultPayer(soldToBocList?: SoldToRelationshipGroup) {
		if (soldToBocList?.need4SteelSettings?.payer) {
			this.form.getFormPayer().setValue(String(soldToBocList.need4SteelSettings.payer));
		}
	}

	private applyDefaultIncotermForShipTo(shipToId: string) {
		if (!shipToId) {
			return;
		}
		const countryCode = this.bocs?.get(shipToId)?.countryCode;
		this.form.getFormIncoterm().setValue(countryCode === 'PL' ? INCOTERM_CIP : DEFAULT_INCOTERM);
	}

	private updateShipmentForShipTo(shipToId: string) {
		if (!shipToId) {
			return;
		}
		const shipments = this.shipmentCacheService.getShipmentsForShipTo(shipToId);
		this.tmodList = shipments.map(s => ({
			code: s.tmode,
			value: getTmodeTrKey(s.tmode)
		}));
		// Keep the current tmode if the new shipTo offers it; otherwise prefer the default
		// (Truck '3') when available, and only then fall back to the first available mode.
		const currentTmode = <string> this.form.getFormTmode().value;
		const hasTmode = (tmode: string) => shipments.some(s => s.tmode === tmode);
		let selectedTmode: string;
		if (hasTmode(currentTmode)) {
			selectedTmode = currentTmode;
		} else if (hasTmode(DEFAULT_TRANSPORT_MODE)) {
			selectedTmode = DEFAULT_TRANSPORT_MODE;
		} else {
			selectedTmode = shipments[0]?.tmode ?? DEFAULT_TRANSPORT_MODE;
		}
		const selectedIncoterm = shipments.find(s => s.tmode === selectedTmode)?.incoterm ?? DEFAULT_INCOTERM;
		this.form.getFormTmode().setValue(selectedTmode);
		this.form.getFormIncoterm().setValue(selectedIncoterm);
	}

	private async checkSoldToShipToError() {
		if (!this.userBocData || this.userBocData.length === 0) {
			this.isSoldTo = false;
			return this.translationService.getTR('eoffer.error.nosoldto');
		}
		if (this.userBocData.filter(v => v.shipTos.length > 0).length === 0) {
			for (const boc of this.userBocData) {
				const noShipto = boc.shipTos.length === 0;
				if (!noShipto) {
					continue;
				}
				this.isShipTo = false;
				this.millOfferService.setOfferListErrorMsg(
					this.translationService.getTR('need4steel.soldto.shipto.error.message')
				);
				await this.router.navigate(['/need4steel/offerlist'], { replaceUrl: true });
			}
		}
		return undefined;
	}
}
